import { type RouteRecordRaw } from "vue-router";
import { RouteNames } from "@shared/types/localTypes/router";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";

export default [
  {
    path: "/login",
    name: RouteNames.Login,
    component: () => import("@/views/partnerPortal/PartnerLogin.vue"),
    children: [],
    beforeEnter: async () => {
      const keyCloakInstance = useKeycloakStore();

      await useKeycloakStore().initializeKeycloak();

      if (keyCloakInstance.keycloak?.authenticated) {
        return { name: RouteNames.Root };
      }
    },
  },
] as RouteRecordRaw[];
